import { useMemo } from "react";
import SimpleTable from "../table/SimpleTable";

const GradableModelsList = ({ gradableModels, setEdit, setEditableGradableModel }) => {
    const columns = useMemo(() => [
        { key: "game", header: "Jogo", width: 120 },
        { key: "name", header: "Nome", width: 180 },
        { key: "edition", header: "Edição", width: 140 },
        { key: "year", header: "Ano", width: 90 },
        { key: "language", header: "Idioma", width: 110 },
        { key: "numbering", header: "Numeração", width: 110 },
        { key: "rarity", header: "Raridade", width: 110 },
        {
            key: "ver", header: "", width: 70, sortable: false, hideable: false, exportable: false,
            cell: ({ row }) => <button type="button" onClick={() => { setEdit(true); setEditableGradableModel(row); }} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Ver</button>,
        },
    ], [setEdit, setEditableGradableModel]);
    return <SimpleTable tableKey="admin-gradable-models" columns={columns} data={gradableModels} />;
};

export default GradableModelsList;
